import { Button } from '../../../../../../common/Atoms/Button';
import { Divider } from '../../../../../../common/Atoms/Divider';
import { Modal } from '../../../../../../common/Atoms/Modal';
import { Paragraph } from '../../../../../../common/Atoms/Typography/Paragraph';

interface BuilderConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  destructive?: boolean;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function BuilderConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  destructive,
  busy,
  onConfirm,
  onCancel,
}: BuilderConfirmModalProps) {
  return (
    <Modal
      title={ title }
      open={ open }
      setOpen={ onCancel }
    >
      <div className={ `flex flex-col items-center mt-6` }>
        <Paragraph variant={ `primary` }>
          { message }
        </Paragraph>

        <Divider weight={ `light` } />

        <div>
          <Button
            color={ `gray` }
            className={ `mr-4` }
            disabled={ busy }
            onClick={ onCancel }
          >
            { `Cancel` }
          </Button>
          <Button
            color={ destructive ? `red` : undefined }
            disabled={ busy }
            onClick={ onConfirm }
          >
            { confirmLabel }
          </Button>
        </div>
      </div>
    </Modal>
  );
}
